import React, { useCallback } from "react"
import {
  Avatar,
  Box,
  Card,
  CardMedia,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useMemo } from "react"
import get from "lodash/get"
import { CustomIcon } from "components/icons"
import { getFeatureDetail } from "utils/feature"
import { useTranslation } from "providers/i18n"
import { useNavigate } from "react-router-dom"
import { useVenue } from "providers/venue"
import _ from "lodash"

export const DepartmentStoreOccupantCard = ({ data, sx, ...props }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isMultiVenueProject } = useVenue()
  const categoryIcon = useMemo(
    () => get(data, "properties.local_categories[0].properties.icon_path"),
    [data]
  )
  const { name, logo, level, venueLogo } = useMemo(
    () => getFeatureDetail(data),
    [data]
  )

  const handleClick = useCallback(
    () => navigate(`/maps/place/${data.id}`),
    [navigate, data?.id]
  )

  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components?.[`DepartmentStoreOccupantCard`] || {}
  const {
    root,
    occupantLogo,
    cardContent,
    levelContainer,
    venueLogo: venueLogoStyle,
    titleText,
    categoryText,
    titleContainer,
    occupantDetailContainer,
    levelContainerWrapper,
    venueLogoContainer,
    occupantIdentityContainer,
    occupantDetailWrapper,
    categoryDetailContainer,
  } = styleOverrides

  const subcategory = _.first(data?.properties?.local_sub_categories)
  const subcategoryName = _.get(subcategory, "properties.name")

  return (
    <Card sx={deepmerge(root, sx)} onClick={handleClick} {...props}>
      <Box sx={occupantLogo}>
        <Avatar src={logo}>
          {logo ? "" : <CustomIcon path={categoryIcon} />}
        </Avatar>
      </Box>
      <Box sx={cardContent}>
        <Box sx={occupantIdentityContainer}>
          <Box sx={titleContainer}>
            <Typography sx={titleText}>{t(name)}</Typography>
          </Box>
          <Box sx={venueLogoContainer}>
            {isMultiVenueProject && venueLogo && (
              <CardMedia
                component="img"
                image={venueLogo}
                sx={venueLogoStyle}
              />
            )}
          </Box>
        </Box>
        <Box sx={occupantDetailWrapper}>
          <Box sx={occupantDetailContainer}>
            <Box sx={categoryDetailContainer}>
              <Typography variant="body2" sx={categoryText}>
                {t(subcategoryName)}
              </Typography>
            </Box>
            <Box sx={levelContainerWrapper}>
              <Box sx={levelContainer}>
                <Typography variant="h6">{t(level)}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  )
}
